import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import api from "../lib/api";
import { toast } from "sonner";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pw1.length < 6) {
      toast.error("La nueva contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (pw1 !== pw2) {
      toast.error("Las nuevas contraseñas no coinciden.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/password/change", {
        current_password: current,
        new_password: pw1,
      });
      setDone(true);
      toast.success("Tu contraseña ha sido actualizada correctamente.");
      setCurrent(""); setPw1(""); setPw2("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Algo salió mal. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppShell title="Cambiar contraseña" subtitle="Mantén tu cuenta segura.">
      <div className="max-w-xl" data-testid="change-password-page">
        <div className="mep-card p-7 md:p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-full bg-[rgba(232,61,132,0.12)] border border-[var(--mep-pink)]/40 flex items-center justify-center text-[var(--mep-pink)]">
              <KeyRound size={20} />
            </div>
            <div>
              <div className="text-eyebrow text-[var(--mep-pink)]">Seguridad</div>
              <h2 className="font-display text-xl font-light tracking-tight">Actualiza tu contraseña</h2>
            </div>
          </div>

          {done ? (
            <div className="p-5 rounded-lg bg-[rgba(212,175,55,0.10)] border border-[var(--mep-gold)]/40 flex items-start gap-3" data-testid="change-success">
              <CheckCircle2 size={22} className="text-[var(--mep-gold)] flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-base text-[var(--mep-text)] font-medium">Tu contraseña ha sido actualizada correctamente.</p>
                <button
                  type="button"
                  onClick={() => navigate("/panel")}
                  className="text-xs text-[var(--mep-gold)] mt-2 underline"
                >
                  Volver al panel
                </button>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Contraseña actual</label>
                <input
                  data-testid="change-current-input"
                  type="password"
                  value={current}
                  required
                  onChange={(e) => setCurrent(e.target.value)}
                  className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
                />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Nueva contraseña</label>
                <input
                  data-testid="change-pw1-input"
                  type="password"
                  value={pw1}
                  required
                  minLength={6}
                  onChange={(e) => setPw1(e.target.value)}
                  className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
                />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Confirmar nueva contraseña</label>
                <input
                  data-testid="change-pw2-input"
                  type="password"
                  value={pw2}
                  required
                  minLength={6}
                  onChange={(e) => setPw2(e.target.value)}
                  className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
                />
              </div>
              <button
                data-testid="change-submit-btn"
                type="submit"
                disabled={loading}
                className="btn-pink w-full py-4 font-semibold"
              >
                {loading ? "Actualizando..." : "Actualizar contraseña"}
              </button>
            </form>
          )}
        </div>
      </div>
    </AppShell>
  );
}
